import { Component, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router, RouterModule } from '@angular/router';
import { BottomSheetMobileHeaderComponent } from '@ui';

import { type Dashboard } from '../../../models';

@Component({
  imports: [BottomSheetMobileHeaderComponent, RouterModule],
  selector: 'avs-li-mobile-dashboards-selector-options',
  templateUrl: './mobile-dashboards-selector-sheet.component.html',
})
export class MobileDashboardsSelectorSheetComponent {
  protected data = inject<{
    dashboards: Dashboard[];
  }>(MAT_BOTTOM_SHEET_DATA);

  private bottomSheetRef = inject<MatBottomSheetRef<MobileDashboardsSelectorSheetComponent>>(MatBottomSheetRef);
  private router = inject(Router);

  protected close() {
    this.bottomSheetRef.dismiss();
  }

  protected async navigateToDashboard(id: string) {
    await this.router.navigate(['dashboards', id]);
    this.close();
  }
}
